import { FormFeedbackRAC as ReactFormFeedback } from "@certn/cascadia-react/components/inputs/_assets/input-wrapper/FormFeedbackRAC";
import { memo } from "react";

import { CascadiaFormFeedbackProps } from "./types";

export const FormFeedback = memo(function (props: CascadiaFormFeedbackProps) {
  return <ReactFormFeedback {...props} />;
});
